module.exports = __webpack_public_path__ + "img/cdown.dec64250.jpg";